import { useState } from 'react';
import Registration from './Registration'; // Assuming Registration is in the same folder
import UserLogin from './Login'; // Assuming Login is in the same folder
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AuthCard = () => {
  const [isLoginView, setIsLoginView] = useState(true);
  
  const {t} = useTranslation("auth")
  const translation = t('auth_card')
  
  const toggleView = () => {
    setIsLoginView((prev) => !prev);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900 p-4 mt-12" >
      <div className="bg-white dark:bg-gray-700 rounded-xl shadow-2xl p-8 w-full max-w-md border border-gray-200 dark:border-gray-700 relative overflow-hidden">
        <h2 className="text-3xl font-extrabold text-gray-900 dark:text-white text-center mb-6">
          {isLoginView ? `${translation.login_heading}` : `${translation.signup_heading}`} 
        </h2>

        {/* Conditional rendering for Login or Registration form */}
        {isLoginView ? (
          <UserLogin onToggleView={toggleView} />
        ) : (
          <Registration onToggleView={toggleView} />
        )}

        <div className="mt-8 text-center text-gray-600 dark:text-gray-100">
          {isLoginView ? (
            <p>
              {translation.not_account}{' '}
              <button
                type="button"
                onClick={toggleView}
                className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-medium transition duration-200"
              >
                {translation.signup}
              </button> 
            </p>
          ) : (
            <p>
              {translation.already_account}{' '}
              <button
                type="button"
                onClick={toggleView}
                className="text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 font-medium transition duration-200"
              >
                {translation.login}
              </button>
            </p>
          )}
        </div>

        <div className="mt-6 text-center text-sm text-gray-500 dark:text-gray-500 space-y-1">
          <NavLink to="/policy" className="text-blue-600 hover:underline dark:text-blue-400">
            {translation.privacy_policy}
          </NavLink>
          <span className="mx-1 dark:text-white"> & </span>
          <NavLink to="/terms_and_condition" className="text-blue-600 hover:underline dark:text-blue-400">
            {translation.terms_conditions}
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AuthCard;